import { render, staticRenderFns } from "./RecebimentoParcialResumo.vue?vue&type=template&id=93e68272"
import script from "./RecebimentoParcialResumo.vue?vue&type=script&lang=js"
export * from "./RecebimentoParcialResumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports